import { render } from "./productView.vue?vue&type=template&id=45f57893"
import script from "./productView.vue?vue&type=script&lang=js"
export * from "./productView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__